import React from 'react'
import CreateCompany from '../../Screens/SystemAdmin/CreateCompany'
import ManageCompany from '../../Screens/SystemAdmin/ManageCompany'
import ManagePayments from '../../Screens/SystemAdmin/ManagePayments'
import Profile from '../../Screens/SystemAdmin/Profile'

const Main = ({ activeScreen, setActiveScreen, isFirstLogin }) => {
  const renderScreen = () => {
    // If first login, only allow profile screen
    if (isFirstLogin && activeScreen !== 'profile') {
      return <Profile />
    }

    switch (activeScreen) {
      case 'create-company':
        return <CreateCompany />
      case 'manage-company':
        return <ManageCompany setActiveScreen={setActiveScreen} />
      case 'manage-payments':
        return <ManagePayments />
      case 'profile':
        return <Profile />
      default:
        return <CreateCompany />
    }
  }

  return (
    <main id="main" className="main">
      {renderScreen()}
    </main>
  )
}

export default Main